// 覆蓋檔案：ui/constants/departments.ts

export type DepartmentId =
  | 'gm'  // 總經理室
  | 'fa'  // 財務部
  | 'ap'  // 行政人資部
  | 'it'  // 資訊部
  | 'lg'  // 法務部
  | 'sl1' // 業務一部
  | 'sl2' // 業務二部
  | 'li'  // 物流部
  | 'pt'  // 採購部
  | 'qc'  // 品保部
  | 'mk'  // 行銷宣傳部
  | 'sys'; // 系統管理

export interface DepartmentOption {
  id: DepartmentId;
  name: string;
  email: string;
  code: string;
}

export const DEPARTMENTS: DepartmentOption[] = [
  { id: 'gm',  code: 'GM',  name: '總經理室',   email: 'gm@lg.app' },
  { id: 'fa',  code: 'FA',  name: '財務部',     email: 'fa@lg.app' },
  { id: 'ap',  code: 'AP',  name: '行政人資部', email: 'ap@lg.app' },
  { id: 'it',  code: 'IT',  name: '資訊部',     email: 'it@lg.app' },
  { id: 'lg',  code: 'LG',  name: '法務部',     email: 'lg@lg.app' },
  { id: 'sl1', code: 'SL1', name: '業務一部',   email: 'sl1@lg.app' },
  { id: 'sl2', code: 'SL2', name: '業務二部',   email: 'sl2@lg.app' },
  { id: 'li',  code: 'LI',  name: '物流部',     email: 'li@lg.app' },
  { id: 'pt',  code: 'PT',  name: '採購部',     email: 'pt@lg.app' },
  { id: 'qc',  code: 'QC',  name: '品保部',     email: 'qc@lg.app' },
  { id: 'mk',  code: 'MK',  name: '行銷宣傳部', email: 'mk@lg.app' },
  { id: 'sys', code: 'SYS', name: '系統管理',   email: 'king@lg.app' },
];

// Compatibility Layers
export const DEPARTMENT_OPTIONS = DEPARTMENTS.map(d => d.name);

export const DEPT_NAME_TO_CODE: Record<string, string> = {};
DEPARTMENTS.forEach(d => { DEPT_NAME_TO_CODE[d.name] = d.code; });

export const DEPT_CODE_TO_NAME: Record<string, string> = {};
DEPARTMENTS.forEach(d => { DEPT_CODE_TO_NAME[d.code] = d.name; });

// New maps (internal helpers)
const DEPT_ID_TO_NAME: Record<string, string> = {};
const DEPT_ID_TO_CODE: Record<string, string> = {};
DEPARTMENTS.forEach(d => {
  DEPT_ID_TO_NAME[d.id] = d.name;
  DEPT_ID_TO_CODE[d.id] = d.code;
});

export function getDeptCode(input: string): string {
  const v = (input || "").trim();
  if (!v) return "OTHER";

  // If it's already an id (lg/fa/...)
  if (DEPT_ID_TO_CODE[v]) return DEPT_ID_TO_CODE[v];

  // If it's already a code (LG/FA/...)
  const upper = v.toUpperCase();
  if (DEPT_CODE_TO_NAME[upper]) return upper;

  // Exact name match
  if (DEPT_NAME_TO_CODE[v]) return DEPT_NAME_TO_CODE[v];

  // Fuzzy match for legacy names
  if (v.includes("人資") || v.includes("人事")) return "AP";
  if (v.includes("採購")) return "PT";
  if (v.includes("總經理")) return "GM";
  if (v.includes("行銷")) return "MK";

  return "OTHER";
}

export function getDeptNameByCode(codeOrId: string): string {
  const v = (codeOrId || "").trim();
  if (!v) return "";

  // If it's an id
  if (DEPT_ID_TO_NAME[v]) return DEPT_ID_TO_NAME[v];

  // If it's a code
  const upper = v.toUpperCase();
  return DEPT_CODE_TO_NAME[upper] || v;
}
